import ShopIQ from '../../images/Shop-IQOS.png';
function ShopIQOS() {
    return (
        <div style={{ marginLeft: '20px', marginRight: '2.5px', marginTop: '20px' }}>
            <img src={ShopIQ} style={{ width: '100%', height: '' }} alt="" />
        </div>
    );
}

export default ShopIQOS;